import { createSlice } from "@reduxjs/toolkit";
import { createListingThunk } from "./createListingThunk";
import { deleteListingThunk } from "./deleteListingThunk";
import { updateListingThunk } from "./updatingListingThunk";

export interface listingStata {
  sellRent: string;
  propertyName: string;
  beds: number;
  baths: number;
  parkingSpot: string;
  furnished: string;
  address: string;
  description: string;
  offer: string;
  price: number;
  images: any;
  uid: string | null;
}

interface intialState {
  loading: boolean;
  error: string | null;
  length: number;
  loadingDelete: boolean;
  errorDelete: string | null;
  loadingUpdate: boolean;
  errorUpdate: string | null;
}
const initialState: intialState = {
  loading: false,
  error: null,
  length: 0,
  loadingDelete: false,
  errorDelete: null,
  loadingUpdate: false,
  errorUpdate: null
};

export const listingSlice = createSlice({
  name: "listing",
  initialState,
  reducers: {
    increaseLength: (state) => {
      state.length++;
    },
    decreaseLength: (state) => {
      state.length--;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(createListingThunk.pending, (state) => {
      state.loading = true;
      return state;
    });
    builder.addCase(createListingThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.length++;
      return state;
    });
    builder.addCase(createListingThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
        ? action.payload.message
        : "Failed to create listing.";
      return state;
    });
    builder.addCase(deleteListingThunk.pending, (state) => {
      state.loadingDelete = true;
      return state;
    });
    builder.addCase(deleteListingThunk.rejected, (state, action) => {
      state.loadingDelete = false;
      state.errorDelete = action.payload
        ? action.payload.message
        : "Failed to delete listing.";
      return state;
    });
    builder.addCase(deleteListingThunk.fulfilled, (state, action) => {
      state.loadingDelete = false;
      state.errorDelete = null;
      return state;
    });
    builder.addCase(updateListingThunk.pending, (state) => {
      state.loadingUpdate = true;
      return state;
    });
    builder.addCase(updateListingThunk.rejected, (state, action) => {
      state.loadingUpdate = false;
      state.errorUpdate = action.payload
        ? action.payload.message
        : "Failed to update listing.";
      return state;
    });
    builder.addCase(updateListingThunk.fulfilled, (state, action) => {
      state.loadingUpdate = false;
      state.errorUpdate = null;
      return state;
    });
  }
});
